import { render, staticRenderFns } from "./modal-termo.vue?vue&type=template&id=0661bc85&"
import script from "./modal-termo.vue?vue&type=script&lang=js&"
export * from "./modal-termo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports